'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeStandardResponse = makeStandardResponse;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeStandardResponse() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      standardResponse = _ref.standardResponse;

  return _I18n2.default.text('conversationsUI.typicalResponseTime.standardResponses.' + standardResponse);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/typical-response-time/operators/makeStandardResponse.js
// module id = 766
// module chunks = 2 3